export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-primary-50/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs md:text-sm font-medium mb-4 md:mb-5">
              每日更新 · 全站免费
            </p>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4 md:mb-5">
              韩漫屋 - 韩漫全集免费在线阅读平台
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading font-semibold mb-5 md:mb-6">
              海量韩漫 · 高清画质 · 追更不等待
            </p>

            <div className="space-y-3 text-foreground-700 text-sm md:text-base leading-relaxed mb-6 md:mb-8 max-w-xl mx-auto lg:mx-0">
              <p>
                韩漫屋汇集海量韩漫全集免费资源，免注册即可畅享全章节阅读体验。无论你钟爱恋爱韩漫的甜蜜细腻、奇幻韩漫的恢弘想象，还是悬疑韩漫的紧张逆转，这里都有你想要的免费韩漫大全。
              </p>
              <p>
                平台坚持日更同步，热门连载韩漫免费全集在线同步韩国本土更新节奏，第一时间呈现最新话。高清原画级画质搭配流畅下拉式阅读，让每一页韩漫的笔触与分镜都尽收眼底。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7 md:mb-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-primary-600 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                  <strong className="text-primary-600">5000+</strong> 部韩漫
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-time-line text-accent-600 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                  <strong className="text-accent-600">每日</strong> 同步更新
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-600 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                  <strong className="text-secondary-600">免注册</strong> 免费阅读
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 md:gap-4">
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline text-center"
              >
                开始阅读
              </a>
              <a
                href="#about"
                onClick={(e) => handleNavClick(e, '#about')}
                className="w-full sm:w-auto px-8 py-3 rounded-lg border-2 border-primary-300 text-primary-700 font-semibold text-sm md:text-base hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer no-underline text-center"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20colorful%20Korean%20manhwa%20comic%20books%20floating%20in%20warm%20ambient%20light%2C%20soft%20pastel%20coral%20and%20cream%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20editorial%20design%20aesthetic%2C%20Korean%20webtoon%20art%20style%20influence%2C%20clean%20composition%20with%20generous%20negative%20space%2C%20warm%20inviting%20mood%2C%20high%20quality%20digital%20art%2C%20minimalist%20yet%20expressive&width=960&height=1200&seq=hero-main-visual&orientation=portrait"
                alt="韩漫屋 - 韩漫全集免费在线阅读平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}